import { Stage, Layer, Rect, Text, Circle, Image } from 'react-konva';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const TemplateCardPreview = ({ item, cardWidth, cardHeight, cardBackgroundColor, stageRef, isFront }) => {
    const raw = JSON.parse(item?.raw);
    const rawIndex = isFront ? 1 : 2;

    return (
        <div key={item?.id}>
            <div className='card-base-grid'>
                <div className='card-body-grid'>
                    <div className='p-2 card-template'>
                        <p className='text-uppercase'>{isFront ? 'Front' : 'Back'}</p>

                        <Stage
                            className=' card-template'
                            ref={stageRef}
                            width={cardWidth}
                            height={cardHeight}
                            scaleX={0.3}
                            scaleY={0.3}
                        >
                            <Layer width={cardWidth} height={cardHeight}>
                                <Rect
                                    id='background'
                                    width={cardWidth}
                                    height={cardHeight}
                                    fill={cardBackgroundColor}
                                />

                                {item &&
                                    raw[rawIndex].combinedObject.map((shape, index) => {
                                        if (shape.property === 'squares' || shape.property === 'lines') {
                                            return (
                                                <Rect
                                                    key={shape.id}
                                                    x={shape.x - 40}
                                                    y={shape.y - 20}
                                                    rotation={shape.rotation}
                                                    width={shape.width}
                                                    height={shape.height}
                                                    cornerRadius={shape.cornerRadius}
                                                    stroke={shape.stroke}
                                                    strokeWidth={shape.strokeWidth}
                                                    id={shape.id}
                                                    fill={shape.fill}
                                                />
                                            );
                                        } else if (shape.property === 'ellipsis') {
                                            return (
                                                <Circle
                                                    key={shape.id}
                                                    x={shape.x - 40}
                                                    y={shape.y - 20}
                                                    rotation={shape.rotation}
                                                    radius={shape.radius}
                                                    fill={shape.fill}
                                                    stroke={shape.stroke}
                                                    strokeWidth={shape.strokeWidth}
                                                    id={shape.id}
                                                />
                                            );
                                        } else if (shape.property === 'texts') {
                                            return (
                                                <Text
                                                    key={shape.id}
                                                    x={shape.x - 40}
                                                    y={shape.y - 20}
                                                    text={shape.content}
                                                    fontSize={shape.fontSize}
                                                    fontFamily={shape.fontFamily}
                                                    fontStyle={shape.fontStyle}
                                                    textDecoration={shape.textDecoration}
                                                    fill={shape.fill}
                                                    align={shape.align}
                                                    width={shape.width}
                                                    height={shape.height}
                                                    wrap={true}
                                                    id={shape.id}
                                                />
                                            );
                                        } else if (shape.property === 'resources') {
                                            const imageObject = new window.Image();
                                            imageObject.src = shape.base64;
                                            return (
                                                <Image
                                                    key={shape.id}
                                                    image={imageObject}
                                                    x={shape.x - 40}
                                                    y={shape.y - 30}
                                                    rotation={shape.rotation}
                                                    width={shape.width}
                                                    height={shape.height}
                                                    id={shape.id}
                                                />
                                            );
                                        }
                                        return null;
                                    })}
                            </Layer>
                        </Stage>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TemplateCardPreview;
